import { Flex, FormErrorMessage, HStack, InputGroup, Text, Textarea } from "@chakra-ui/react";

const AppTextArea = (props: any) => {
  const { label, showErrorMessage, errorMessage, sx, ...restProps } = props;
  return (
    <>
        <Flex
          gap="4px"
          flexDirection="column"
          alignItems="start"
          width={"100%"}
        >
          {label && <HStack>
            <Text>{label} </Text>
            {restProps.required && <span style={{ color: "red" }}>*</span>}
          </HStack>}
          <InputGroup size="sm">
            <Textarea rows={3} {...restProps} type={restProps.type} />
          </InputGroup>
        </Flex>
      {showErrorMessage && (
        <FormErrorMessage style={{ color: "red" }}>
          {errorMessage}
        </FormErrorMessage>
      )}
    </>
  );
};

export default AppTextArea;
